import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B01D02SalesPaymentPage } from '../b01-d02-sales-payment/b01-d02-sales-payment';
import { B04LaybyPage } from '../b04-layby/b04-layby';
import { B01SalesPage } from '../b01-sales/b01-sales';

/**
 * Generated class for the B04D02LaybyListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
interface soInfo{
  SO_ID: number;
  SO_NO: string;
  CARD: string;
  DATETIME: string;
  TOTAL: number;
  TOTAL_TAX: number;
  GRAND_TOTAL: number;

  SO_STATUS_ID: number;
  STATUS: string;

  USER_ID: number;
  USER_NAME: string;
}

interface SOLInfo{
  SOL_DESC: string;
  QTY: string;
  UNIT_PRICE: string;
  DISC_PERC: string;
  TAX_PERC: number;
  DATETIME: number; 
  SOL_TOTAL: number; 
  GRAND_SOL_TOTAL: number;

  TOTAL: number;
  TOTAL_TAX: number;
  GRAND_TOTAL: number;
  INVENTORY_ID: number;
}

@IonicPage()
@Component({
  selector: 'page-b04-d02-layby-list',
  templateUrl: 'b04-d02-layby-list.html',
})
export class B04D02LaybyListPage {

  loading: any;
  Status: any;
  SO_ID: any;
  SOLArr: SOLInfo[] = [];
  SOLItems: SOLInfo[] = [];
  public errorMessage: any = "";
  subtotal: any;
  total_tax: any;
  total: any;
  public item_data = [];  
  public so_total_price:number=0.00;
  public total_sub:number=0.00;
  public subTotal:number=0.00;

  constructor(public navCtrl: NavController, public navParams: NavParams, public serviceapi: ServiceApiProvider,
              public loadingCtrl: LoadingController, public alertCtrl : AlertController) {

    this.SO_ID = this.navParams.get('paramID');        //SO ID
    //console.log( this.SOL_ID);
    let sortby= "No";
    let sorttype= "No";
    
    let tbl = ["SOL2"];
    let column = ["SO_ID"];
    let value = [this.SO_ID];

/*     let tblkey = ["SO_ID"];
    let fktbl = ["SO2"];
    let fkkey = ["SO_ID"]; */
    let tblkey = "No";
    let fktbl = "No";
    let fkkey = "No";
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");

    this.serviceapi.readdata(json_data,"SOL2","1","1").then((result) => {
      //this.loading.dismiss();
      this.Status = result["Message"];
    
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.SOLArr = Records;
        this.SOLItems = this.SOLArr;

/*         this.subtotal = this.SOLArr[0].TOTAL;
        this.total_tax = this.SOLArr[0].TOTAL_TAX;
        this.total = this.SOLArr[0].GRAND_TOTAL;
        console.log(this.SOLItems); */
        console.log(this.SOLArr)
        this.subTotal=0;
        this.total_tax = 0;
        for (let x = 0; x < this.SOLArr.length; x++) {  //loop through the array
          this.subTotal += +(this.SOLArr[x].SOL_TOTAL);  //Do the math!
          this.total_tax += +(this.SOLArr[x].TOTAL_TAX); 
        }
        this.total_sub = Number(this.subTotal.toFixed(2));
/*         this.total = Number((this.total_sub + this.total_tax).toFixed(2)); */
        this.total = Number((this.total_sub).toFixed(2));
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
      this.loading.dismiss();
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B07D02LaybyListPage');
  }

  cancel(){
    this.navCtrl.pop();
  }

  navToSales(){

    let SOL_length = this.SOLArr.length;

    for (let i=0; i < SOL_length; i++){    
      var newItem_data ={
        "ID": 0,
        "description" : '',
        "quantity" : '',
        "each" : '',
        "discount_perc" : 0,
        "tax_perc" : 0,
        "total_tax" : 0,
        "total_sub" : 0,
        "sol_total_price" : 0,
      };
  
      newItem_data.quantity = this.SOLArr[i].QTY;
      newItem_data.description = this.SOLArr[i].SOL_DESC;
      newItem_data.each = this.SOLArr[i].UNIT_PRICE;
      newItem_data.total_sub = this.SOLArr[i].SOL_TOTAL;
      newItem_data.tax_perc = this.SOLArr[i].TAX_PERC;
      newItem_data.total_tax = this.SOLArr[i].TOTAL_TAX;
      newItem_data.sol_total_price = this.SOLArr[i].GRAND_SOL_TOTAL;
      newItem_data.ID = this.SOLArr[i].INVENTORY_ID;
  
      console.log(newItem_data);
      this.item_data.push(newItem_data); 
      
      this.subTotal=0;
      let taxTotal = 0;
      for (let x = 0; x < this.item_data.length; x++) {  //loop through the array
        this.subTotal += +(this.item_data[x].total_sub);  //Do the math!
         taxTotal += +this.item_data[x].total_tax; 
      }
/*       taxTotal = Number(newItem_data.total_tax); */
      this.total_sub = Number((this.subTotal).toFixed(2));
/*       this.so_total_price = Number((this.total_sub + taxTotal).toFixed(2)); */
      this.so_total_price = Number((this.total_sub).toFixed(2));
    }
    console.log(this.item_data);
    this.navCtrl.push(B01SalesPage,
    { Link: this.item_data, 
      total_Amount: this.so_total_price, 
      total_Sub: this.total_sub,
      salesParam: '2',
      layby_SO_ID: this.SO_ID,
    });
    /* this.navCtrl.push(B01D02SalesPaymentPage,
      { total_Amount: this.total, 
        salesParam: '2',
      }); */
  }

  deleteLayBy(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to delete? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
              
            this.showLoader();
            this.serviceapi.deletedata('SO2', 'SO_ID', this.SO_ID).then((result) => {       //delete SO2
          
              this.Status = result["Message"];
              if (this.Status == "1"){
        
                this.serviceapi.deletedata('SOL2', 'SO_ID', this.SO_ID).then((result) => {  //delete SOL2
                  this.loading.dismiss();
                  this.Status = result["Message"];
                  if (this.Status == "1"){
                    this.navCtrl.setRoot(B04LaybyPage);
                  }
                  else {
                    this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                  }
                }, (err) => {
                  this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
                  this.loading.dismiss();
                });
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }
            }, (err) => {
              this.errorMessage = "Loading Error. Please try again. Error Code: '" + err + "'";
              this.loading.dismiss();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000,
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b04-d02-layby-list/b04-d02-layby-list.ts